module.exports = "<span title=\"{{row.eid}}\" ng-class=\"[row.term.class + '-text']\">{{row.eid}}</span>"